(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koppa-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('koppa-product')) {
    customElements.define('koppa-product', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.controller || !this.isConnected) return;

        this.controller = new AbortController();

        const listenerOptions = {
          signal: this.controller.signal
        };

        this.slides = Array.from(
          this.querySelectorAll('[data-slide]')
        );

        this.index = Math.max(
          0,
          this.slides.findIndex(slide => !slide.hidden)
        );

        this.selector = this.querySelector('[data-variant]');
        this.optionButtons = Array.from(
          this.querySelectorAll('[data-option-position][data-option-value]')
        );

        this.stickyBar = this.querySelector('[data-sticky-buy]');
        this.stickyButton = this.querySelector('[data-sticky-add-button]');
        this.primaryAddButton = this.querySelector('[data-add-button]');

        this.syncStickyButton = () => {
          if (!this.stickyButton || !this.primaryAddButton) return;
          this.stickyButton.disabled = this.primaryAddButton.disabled;
          this.stickyButton.textContent =
            this.primaryAddButton.textContent.trim();
        };

        this.quantityInput = this.querySelector('input[name="quantity"]');
        this.stickyQuantity = this.querySelector('[data-sticky-quantity]');
        this.querySelectorAll('[data-main-quantity-step]').forEach(button => {
          button.addEventListener('click', () => {
            if (Number(button.dataset.mainQuantityStep) < 0) this.quantityInput.stepDown();
            else this.quantityInput.stepUp();
            this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }, listenerOptions);
        });
        this.syncStickyQuantity = () => {
          const source = this.quantityInput;
          this.querySelectorAll('[data-main-quantity-step]').forEach(button => {
            button.disabled = Number(button.dataset.mainQuantityStep) < 0
              ? Number(source.value) <= (Number(source.min) || 1)
              : source.hasAttribute('max') && Number(source.value) >= Number(source.max);
          });
          const target = this.stickyQuantity;
          if (!source || !target) return;
          ['min', 'max', 'step'].forEach(attribute => {
            if (source.hasAttribute(attribute)) target.setAttribute(attribute, source.getAttribute(attribute));
            else target.removeAttribute(attribute);
          });
          target.value = source.value;
          this.querySelectorAll('[data-quantity-step]').forEach(button => {
            const value = Number(source.value);
            button.disabled = Number(button.dataset.quantityStep) < 0
              ? value <= Number(source.min || 1)
              : source.hasAttribute('max') && value >= Number(source.max);
          });
        };

        if (this.stickyBar && this.stickyButton && this.primaryAddButton && this.quantityInput && this.stickyQuantity) {
          const syncMobileBar = () => {
            this.stickyBar.hidden = !window.matchMedia('(max-width: 899px)').matches;
            this.syncStickyButton();
            this.syncStickyQuantity();
          };
          this.stickyButton.addEventListener('click', () => {
            if (this.primaryAddButton.disabled) return;
            this.primaryAddButton.click();
          }, listenerOptions);
          this.querySelectorAll('[data-quantity-step]').forEach(button => {
            button.addEventListener('click', () => {
              if (Number(button.dataset.quantityStep) < 0) this.quantityInput.stepDown();
              else this.quantityInput.stepUp();
              this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
              this.syncStickyQuantity();
            }, listenerOptions);
          });
          this.stickyQuantity.addEventListener('change', () => {
            const minimum = Number(this.quantityInput.min) || 1;
            const increment = Number(this.quantityInput.step) || 1;
            let value = Math.max(minimum, Math.round((Number(this.stickyQuantity.value) - minimum) / increment) * increment + minimum);
            if (this.quantityInput.hasAttribute('max')) {
              const maximum = Number(this.quantityInput.max);
              value = Math.min(value, minimum + Math.floor((maximum - minimum) / increment) * increment);
            }
            this.quantityInput.value = Number.isFinite(value) ? value : minimum;
            this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            this.syncStickyQuantity();
          }, listenerOptions);
          this.quantityInput.addEventListener('change', this.syncStickyQuantity, listenerOptions);
          window.addEventListener('resize', syncMobileBar, listenerOptions);
          syncMobileBar();
        }

        this.addEventListener('click', event => {
          const direction = event.target.closest('[data-direction]');
          const thumbnail = event.target.closest('[data-thumbnail]');

          if (direction && this.contains(direction)) {
            this.show(
              this.index + Number(direction.dataset.direction)
            );
          }

          if (thumbnail && this.contains(thumbnail)) {
            const index = this.slides.findIndex(
              slide => slide.dataset.slide === thumbnail.dataset.thumbnail
            );

            if (index >= 0) this.show(index);
          }
        }, listenerOptions);

        this.selector?.addEventListener(
          'change',
          () => {
            this.syncOptionButtonsFromVariant(this.selector.selectedOptions[0]);
            this.updateVariant(true);
          },
          listenerOptions
        );

        this.optionButtons.forEach(button => {
          button.addEventListener('click', () => {
            if (button.getAttribute('aria-disabled') === 'true') return;

            this.optionButtons
              .filter(item => item.dataset.optionPosition === button.dataset.optionPosition)
              .forEach(item => item.setAttribute('aria-pressed', 'false'));

            button.setAttribute('aria-pressed', 'true');
            this.syncVariantFromOptions(true);
          }, listenerOptions);
        });

        window.addEventListener('popstate', () => {
          if (!this.selector) return;

          const variantId = new URL(
            window.location.href
          ).searchParams.get('variant');

          const option = Array.from(this.selector.options).find(
            item => item.value === variantId
          );

          if (option) {
            this.selector.value = option.value;
            this.syncOptionButtonsFromVariant(option);
            this.updateVariant(false);
          }
        }, listenerOptions);

        const stage = this.querySelector('.kp__stage');
        let start = null;
        this.suppressImageTapUntil = 0;
        let wheelDistance = 0;
        let lastWheelChange = 0;
        stage?.addEventListener('wheel', event => {
          if (this.dataset.swipe !== 'true' || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
          event.preventDefault();
          if (Date.now() - lastWheelChange < 220) return;
          wheelDistance += event.deltaX;
          if (Math.abs(wheelDistance) >= 28) {
            this.show(this.index + (wheelDistance > 0 ? 1 : -1));
            this.suppressImageTapUntil = Date.now() + 400;
            lastWheelChange = Date.now();
            wheelDistance = 0;
          }
        }, { ...listenerOptions, passive: false });

        stage?.addEventListener('touchstart', event => {
          if (this.dataset.swipe === 'true' && event.touches.length === 1) {
            start = {
              x: event.touches[0].clientX,
              y: event.touches[0].clientY
            };
          } else {
            start = null;
          }
        }, {
          ...listenerOptions,
          passive: true
        });

        stage?.addEventListener('touchcancel', () => {
          start = null;
        }, {
          ...listenerOptions,
          passive: true
        });

        stage?.addEventListener('touchend', event => {
          if (!start || !event.changedTouches.length) return;

          const dx = event.changedTouches[0].clientX - start.x;
          const dy = event.changedTouches[0].clientY - start.y;

          if (Math.abs(dx) > 24 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            this.suppressImageTapUntil = Date.now() + 450;
            this.show(this.index + (dx < 0 ? 1 : -1));
          }

          start = null;
        }, {
          ...listenerOptions,
          passive: true
        });

        this.imageDialog = this.querySelector('[data-image-dialog]');
        this.viewerImage = this.querySelector('[data-viewer-image]');
        this.viewerViewport = this.querySelector('[data-viewer-viewport]');
        this.viewerZoom = 1;
        this.applyViewerZoom = value => {
          if (!this.viewerImage || !this.viewerViewport) return;
          this.viewerZoom = this.dataset.imageZoom === 'true' ? Math.max(1, Math.min(3, value)) : 1;
          const ratio = this.viewerImage.naturalWidth / this.viewerImage.naturalHeight || 1;
          const base = Math.min(this.viewerViewport.clientWidth - 24, (this.viewerViewport.clientHeight - 100) * ratio);
          this.viewerImage.style.width = Math.max(1, base * this.viewerZoom) + 'px';
          this.viewerImage.style.height = 'auto';
          this.querySelectorAll('[data-viewer-zoom]').forEach(button => {
            button.disabled = Number(button.dataset.viewerZoom) < 0 ? this.viewerZoom <= 1 : this.viewerZoom >= 3;
          });
        };
        this.closeImageViewer = () => {
          if (!this.imageDialog?.open) return;
          this.imageDialog.close();
        };
        if (this.imageDialog && this.viewerImage && this.viewerViewport) {
          this.viewerImage.addEventListener('load', () => this.applyViewerZoom(this.viewerZoom), listenerOptions);
          this.querySelectorAll('[data-open-image]').forEach(button => {
            button.addEventListener('click', () => {
              if (Date.now() < this.suppressImageTapUntil || this.imageDialog.open) return;
              const image = button.querySelector('img');
              if (!image) return;
              this.viewerImage.alt = image.alt;
              this.viewerImage.src = button.dataset.fullImage || image.currentSrc || image.src;
              this.viewerZoom = 1;
              this.previousBodyOverflow = document.body.style.overflow;
              document.body.style.overflow = 'hidden';
              this.imageDialog.showModal();
              this.viewerViewport.scrollTo(0, 0);
              this.applyViewerZoom(1);
            }, listenerOptions);
          });
          this.querySelector('[data-viewer-close]')?.addEventListener('click', this.closeImageViewer, listenerOptions);
          this.imageDialog.addEventListener('close', () => {
            document.body.style.overflow = this.previousBodyOverflow ?? '';
          }, listenerOptions);
          this.querySelectorAll('[data-viewer-zoom]').forEach(button => {
            button.addEventListener('click', () => this.applyViewerZoom(this.viewerZoom + Number(button.dataset.viewerZoom)), listenerOptions);
          });
          let pinch = null;
          const distance = touches => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);
          this.viewerViewport.addEventListener('touchstart', event => {
            pinch = this.dataset.imageZoom === 'true' && event.touches.length === 2
              ? { distance: distance(event.touches), zoom: this.viewerZoom }
              : null;
          }, { ...listenerOptions, passive: true });
          this.viewerViewport.addEventListener('touchmove', event => {
            if (!pinch || event.touches.length !== 2 || !pinch.distance) return;
            event.preventDefault();
            this.applyViewerZoom(pinch.zoom * distance(event.touches) / pinch.distance);
          }, { ...listenerOptions, passive: false });
          this.viewerViewport.addEventListener('touchend', () => { pinch = null; }, listenerOptions);
          this.viewerViewport.addEventListener('touchcancel', () => { pinch = null; }, listenerOptions);
          window.addEventListener('resize', () => {
            if (this.imageDialog.open) this.applyViewerZoom(this.viewerZoom);
          }, listenerOptions);
        }

        this.updateVariant(false, false);
        this.show(this.index);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.imageDialog?.open) {
          this.imageDialog.close();
          document.body.style.overflow = this.previousBodyOverflow ?? '';
        }
        this.controller?.abort();
        this.stickyObserver?.disconnect();
        this.stickyObserver = null;
        this.controller = null;
      }

      show(index) {
        if (!this.slides?.length || !Number.isInteger(index)) return;

        const previousIndex = this.index;
        this.index = (
          (index % this.slides.length) + this.slides.length
        ) % this.slides.length;

        this.slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
        });

        if (previousIndex !== this.index && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          const direction = index > previousIndex ? 1 : -1;
          this.slides[this.index].animate([{ transform: 'translateX(' + direction * 60 + 'px)', opacity: .6 }, { transform: 'translateX(0)', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.7,.3,1)' });
        }
        this.querySelectorAll('[data-thumbnail]').forEach(button => {
          if (button.dataset.thumbnail === this.slides[this.index].dataset.slide) button.parentElement.scrollTo({ left: Math.max(0, button.offsetLeft - button.parentElement.offsetLeft - button.parentElement.clientWidth / 2 + button.clientWidth / 2), behavior: 'smooth' });
        });

        const activeId = this.slides[this.index].dataset.slide;

        this.querySelectorAll('[data-thumbnail]').forEach(button => {
          button.setAttribute(
            'aria-pressed',
            String(button.dataset.thumbnail === activeId)
          );
        });

        const counter = this.querySelector('[data-counter]');

        if (counter) {
          counter.textContent =
            `${this.index + 1} / ${this.slides.length}`;
        }
      }

      syncVariantFromOptions(updateURL) {
        const selected = {};
        this.querySelectorAll('[data-option-group]').forEach(group => {
          const active = group.querySelector('[data-option-value][aria-pressed="true"]');
          if (active) selected[group.dataset.optionGroup] = active.dataset.optionValue;
        });

        const option = Array.from(this.selector?.options || []).find(item => {
          return ['1', '2', '3'].every(position => {
            if (!selected[position]) return true;
            return item.dataset['option' + position] === selected[position];
          });
        });

        if (!option) return;
        this.selector.value = option.value;
        this.updateVariant(updateURL);
      }

      syncOptionButtonsFromVariant(option) {
        if (!option) return;
        ['1', '2', '3'].forEach(position => {
          const value = option.dataset['option' + position];
          if (!value) return;
          this.optionButtons
            ?.filter(button => button.dataset.optionPosition === position)
            .forEach(button => {
              button.setAttribute('aria-pressed', String(button.dataset.optionValue === value));
            });
        });
      }

      refreshOptionAvailability() {
        const selected = {};
        this.querySelectorAll('[data-option-group]').forEach(group => {
          const active = group.querySelector('[data-option-value][aria-pressed="true"]');
          if (active) selected[group.dataset.optionGroup] = active.dataset.optionValue;
        });

        this.optionButtons?.forEach(button => {
          const available = Array.from(this.selector?.options || []).some(item => {
            if (item.dataset.available !== 'true') return false;
            return ['1', '2', '3'].every(position => {
              if (position === button.dataset.optionPosition) {
                return item.dataset['option' + position] === button.dataset.optionValue;
              }
              if (!selected[position]) return true;
              return item.dataset['option' + position] === selected[position];
            });
          });
          button.setAttribute('aria-disabled', String(!available));
        });
      }

      updateVariant(updateURL, updateMedia = true) {
        const option = this.selector?.selectedOptions[0];
        if (!option) return;

        const price = this.querySelector('[data-price-display]');

        if (price) {
          price.textContent = option.dataset.price || '';
        }

        const compare = this.querySelector('[data-compare-display]');

        if (compare) {
          compare.textContent = option.dataset.compare || '';
          compare.hidden = !option.dataset.compare;
        }

        const button = this.querySelector('[data-add-button]');

        if (button) {
          button.disabled = option.dataset.available !== 'true';
          button.textContent = button.disabled
            ? this.dataset.sold
            : this.dataset.add;
        }

        this.syncStickyButton?.();

        const quantity = this.querySelector('input[name="quantity"]');

        if (quantity) {
          const min = Math.max(
            1,
            Number(option.dataset.min) || 1
          );

          const step = Math.max(
            1,
            Number(option.dataset.step) || 1
          );

          const max = Number(option.dataset.max);

          quantity.min = min;
          quantity.step = step;

          if (option.dataset.max && Number.isFinite(max)) {
            quantity.max = max;
          } else {
            quantity.removeAttribute('max');
          }

          let value = Number(quantity.value);

          if (!Number.isFinite(value) || value < min) {
            value = min;
          }

          value = min + Math.floor((value - min) / step) * step;

          if (option.dataset.max && value > max) {
            value = min + Math.floor((max - min) / step) * step;
          }

          quantity.value = Math.max(min, value);
        }

        this.syncStickyQuantity?.();

        const index = this.slides.findIndex(
          slide => slide.dataset.slide === option.dataset.media
        );

        if (updateMedia && index >= 0) this.show(index);

        this.syncOptionButtonsFromVariant(option);
        this.refreshOptionAvailability();

        if (updateURL) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', option.value);

          window.history.replaceState(
            window.history.state,
            '',
            url
          );
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koppa-recommendations"] && !Shopify.designMode) return;
  try {
    
if (!window.koppaRecommendationsTapBound) {
  window.koppaRecommendationsTapBound = true;
  document.addEventListener('click', function(event) {
    const card = event.target.closest('.krecs__card');
    if (!card || !matchMedia('(hover:none)').matches || event.detail === 0 || !card.querySelector('.krecs__photo--secondary')) return;
    if (!card.classList.contains('is-preview')) {
      event.preventDefault();
      document.querySelectorAll('.krecs__card.is-preview').forEach(function(item) { item.classList.remove('is-preview'); });
      card.classList.add('is-preview');
    }
  });
  document.addEventListener('pointerdown', function(event) {
    if (!event.target.closest('.krecs__card')) {
      document.querySelectorAll('.krecs__card.is-preview').forEach(function(item) { item.classList.remove('is-preview'); });
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
